import React, { useState } from 'react';

const PasswordInput = ({
  id,
  name,
  value,
  defaultValue,
  onChange,
  placeholder = '••••••••',
  required = false,
  minLength,
  autoComplete = 'current-password',
}) => {
  const [visible, setVisible] = useState(false);

  const inputProps = {
    id,
    name,
    placeholder,
    required,
    minLength,
    autoComplete,
    onChange,
    type: visible ? 'text' : 'password',
  };

  if (value !== undefined) {
    inputProps.value = value;
  }
  if (defaultValue !== undefined) {
    inputProps.defaultValue = defaultValue;
  }

  return (
    <div className="tamcare-input-wrap tamcare-input-wrap--password">
      <i className="fa-solid fa-lock" aria-hidden="true" />
      <input {...inputProps} />
      <button
        type="button"
        className="tamcare-password-toggle"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
        tabIndex={-1}
      >
        <i className={visible ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'} aria-hidden="true" />
      </button>
    </div>
  );
};

export default PasswordInput;
